var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('a-form-item',{staticClass:"address",attrs:{"label":_vm.data.fieldname}},[_c('div',{directives:[{name:"decorator",rawName:"v-decorator",value:([
      _vm.fieldkey,
      {
        initialValue: _vm.fieldvalue,
        trigger: [],
        rules: [
          {
            required: _vm.isneeded,
            message: _vm.enterPlaceholder + _vm.data.fieldname
          },
          {
            validator: _vm.checkValue
          }
        ]
      }
    ]),expression:"[\n      fieldkey,\n      {\n        initialValue: fieldvalue,\n        trigger: [],\n        rules: [\n          {\n            required: isneeded,\n            message: enterPlaceholder + data.fieldname\n          },\n          {\n            validator: checkValue\n          }\n        ]\n      }\n    ]"}],staticClass:"wrap"},[_c('div',{staticClass:"code-line"},[_c('linkage',{attrs:{"default-value":_vm.routes,"get-data":_vm.getData,"search-data":_vm.searchData,"report-search":_vm.reportSearch,"has-child":item => item.haschildren !== 0},on:{"change":_vm.completeHandle}},[_c('div',{staticClass:"select-box"},[_c('a-input',{attrs:{"read-only":"","value":_vm.codeDesc,"placeholder":_vm.placeholder,"show-search":_vm.showSearch}}),_c('i',{staticClass:"iconfont iconicon-test19",attrs:{"slot":"icon"},slot:"icon"})],1)])],1),_c('div')])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }